import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-informative-no-result',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './informative-no-result.component.html',
  styleUrl: './informative-no-result.component.scss'
})
export class InformativeNoResultComponent {

}
